/**
 * @fileoverview CSS module for rendering ICF (Informed Consent Form) components
 * Provides styles for displaying PDF documents and scrollable containers
 *
 * @example
 * // Usage in component:
 * import styles from './ICFRenderer.module.css';
 *
 * <div className={styles.container}>
 *   <div className={styles.pdf_container}>
 *     <div className={styles.pdf}>
 *       <div className={styles.page}>
 *
 *       </div>
 *     </div>
 *   </div>
 * </div>
 */


.container {
    position: relative;
    min-height: 100%;
    display: flex;
    flex-direction: column;
    flex: 1;
    padding-top: 24px;
    margin: -24px -26px 0;
    background: var(--indigo100);
}

.pdf_container {
    position: relative;
    overflow-y: scroll;
    scrollbar-color: var(--indigo100);
    margin: 0 0.5rem;
}

.pdf_container::-webkit-scrollbar {
    background: var(--indigo100);
    width: 0.5rem;
}

.pdf_container::-webkit-scrollbar-thumb {
    background: var(--neutural000);
    border-radius: 100px;
    width: 0.5rem;
    box-shadow: 0px 0px 1px rgba(49, 46, 129, 0.32), 0px 1px 2px rgba(49, 46, 129, 0.12),
        0px 2px 4px rgba(49, 46, 129, 0.08);
}

.pdf {
    display: flex;
    justify-content: flex-end;
    height: calc(100vh - 400px);
}

.page {
    background-color: white;
    max-width: calc(100% - 3rem - 1.5rem);
    padding: 0 1.5rem 1.5rem;
    margin-right: 0.5rem;
    border-radius: 0.75rem 0.75rem 0 0;
    height: max-content;
    overflow: hidden;
}

.page tbody {
    display: grid;
    gap: 1rem;
}

.page table {
    margin-bottom: 1.5rem;
}

.page tbody tr {
    display: grid;
    grid-template-columns: 1fr;
}

.page tbody {
    display: grid;
    gap: 1rem;
}

.page table {
    margin-bottom: 1.5rem;
}

.page tbody tr {
    display: grid;
    grid-template-columns: 1fr;
}

.page h1 {
    display: block;
    padding: 3rem 3rem 1.75rem;
    margin: 0 -3rem 1.75rem;
    font-size: 1.5rem;
    font-weight: 500;
    line-height: 1.75rem;
    letter-spacing: -0.019em;
    background: linear-gradient(90deg, #eef2ff 0.77%, rgba(238, 242, 255, 0) 100%);
}

.topFade {
    position: absolute;
    width: 100%;
    height: 32px;
    top: 0px;

    background: linear-gradient(0deg, #e0e7ff 0%, rgba(224, 231, 255, 0) 100%);
    transform: matrix(1, 0, 0, -1, 0, 0);
}

.bottomFade {
    position: absolute;
    width: 100%;
    height: 32px;
    bottom: 0px;

    background: linear-gradient(180deg, #e0e7ff 0%, rgba(224, 231, 255, 0) 100%);
    transform: matrix(1, 0, 0, -1, 0, 0);
}

.gap {
    height: 24px;
}

.button_container {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    margin: 8px 0 0;
    flex-direction: column-reverse;
    margin-top: auto;
}

.button_container button {
    width: 100%;
}

@media only screen and (min-width: 768px) {
    .pdf {
        padding-left: 12px;
        height: 400px;
    }

    .pdf_container {
        margin: 0 1.5rem;
    }

    .container {
        margin: -48px -50px 0;
        padding-top: 48px;
    }

    .button_container {
        flex-direction: row;
    }

    .button_container button {
        width: auto;
    }

    .page {
        max-width: calc(640px - 6rem);
        padding: 0 3rem 1.5rem;
        margin-right: 1.5rem;
    }

    .page tbody tr {
        grid-template-columns: 1fr 1fr;
    }
}
